/**
 * Compute the gaussian value
 * @param {number} value
 * @param {number} sigma
 */
export function gaussian(value, sigma) {
    const normValue = value / (sigma + 1e-9);
    return Math.exp(-0.5 * normValue * normValue);
}
